module.exports = __webpack_public_path__ + "static/media/delete-series.37e250bc.svg";